import React from "react";

import { Spinner, FluentProvider, makeStyles, } from "@fluentui/react-components";

import { useTeams } from "@microsoft/teamsfx-react";
import { TeamsUserCredential, ErrorWithCode, ErrorCode } from "@microsoft/teamsfx";

import configOptions from "../config";

const useStyles = makeStyles({
    provider: {
        flex: "1"
    },
    spinner: {
        position: "fixed",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 99,
    },
});

interface TeamsFxContextProps {
    credentials: TeamsUserCredential;
}

const TeamsFxContext = React.createContext<TeamsFxContextProps>(null!);

export function TeamsFxProvider({ children }: { children: React.ReactNode }) {
    const styles = useStyles();

    const { loading, theme } = useTeams()[0];

    const [isLoggedIn, setIsLoggedIn] = React.useState<boolean>(false);

    const credentials = React.useMemo(() => new TeamsUserCredential({
        initiateLoginEndpoint: configOptions.startLoginPageUrl,
        clientId: configOptions.clientId,
    }), []);

    React.useEffect(() => {
        const login = async () => {
            try {
                const credentials = new TeamsUserCredential({
                    initiateLoginEndpoint: configOptions.startLoginPageUrl,
                    clientId: configOptions.clientId,
                });
                await credentials.login(configOptions.scope);
                var token = await credentials.getToken(configOptions.scope);
                if (token?.token) {
                    localStorage.setItem("accessToken", token.token);
                }
                setIsLoggedIn(true);
            } catch (ex: unknown) {
                console.error(ex);
                if (ex instanceof ErrorWithCode && ex.code !== ErrorCode.ConsentFailed) {
                    throw ex;
                }
                else {
                    return;
                }
            }
        };
        login();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <TeamsFxContext.Provider value={{ credentials }}>
            <FluentProvider
                className={styles.provider}
                theme={theme}
            >
                {
                    loading || !isLoggedIn ?
                        <Spinner className={styles.spinner} />
                        :
                        children
                }
            </FluentProvider>
        </TeamsFxContext.Provider>
    );
}

export function useTeamsFxContext() {
    return React.useContext(TeamsFxContext);
}